import { netsuiteIntegrationSelectors } from '@vy/app-selectors';
import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../types/boolean-flag';
import type {
  NetSuiteConfigurationControl,
  NetSuiteConfigurationFormValues,
} from '../../NetSuiteConfigurationFormSchema';
import { AUTOMATICALLY_EXPORT_CUSTOMERS_OPTIONS } from './constants';

type CustomersConfigurationSectionProps = {
  control: NetSuiteConfigurationControl;
  defaultValues: NetSuiteConfigurationFormValues;
};

export const CustomersConfigurationSection: FC<CustomersConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Customers" iconName="Customers">
    <Controller
      name="autoExportCustomers"
      control={control}
      defaultValue={defaultValues.autoExportCustomers}
      render={({ field: { value, onChange } }) => (
        <div data-vy={netsuiteIntegrationSelectors.configuration.autoExportCustomersToggle}>
          <RadioGroup
            title="Choose how to export customers to NetSuite"
            value={getFlagFromStatus(value)}
            onChange={(selected) => onChange(getStatusByFlag(selected))}
            keyExtractor={(option) => option.value}
            options={AUTOMATICALLY_EXPORT_CUSTOMERS_OPTIONS}
          />
        </div>
      )}
    />
  </ConfigurationSection>
);
